import React from 'react';
import './IllustrativeDisclaimer.css';

interface IllustrativeDisclaimerProps {
  className?: string;
}

export const IllustrativeDisclaimer: React.FC<IllustrativeDisclaimerProps> = ({ className }) => (
  <span className={`illus-disclaimer${className ? ` ${className}` : ''}`}>
    Images are for illustrative purposes.
  </span>
);
